import api from "./api";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_CONFIG = API_URL_VERSION + "config"

export const configService = {
    get: async () => {
        try {
            const response = await api.get(ENDPOINT_CONFIG);
            return response.data;
        } catch (error) {

        }
    }
}
